import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Scene } from "./Scene";
import { useHitFx } from "./fx";
import { STEP_SETS } from "./copy";
import { useSlow } from "./hooks";
import { useFullLoaderState } from "./store";

export const Segments = ({ className }) => (
  <div data-fx="bar" className={className}>{Array.from({ length: 20 }, (_, i) => <div key={i} />)}</div>
);

export const SlowNotice = ({ onRetry, testid }) => (
  <div className="hl-slow" data-testid={`${testid}-slow`}>
    <span className="hl-mono">ESTO ESTÁ TARDANDO MÁS DE LO NORMAL</span>
    {onRetry && <button type="button" className="hl-retry" onClick={onRetry} data-testid={`${testid}-retry`}>Reintentar</button>}
  </div>
);

function Steps({ steps }) {
  return (
    <div className="hl-steps">
      {steps.map((st) => (
        <div key={st.n} data-fx="step" data-st="0" className="hl-step"><span data-fx="mark" className="hl-mark">··</span><span>{st.n}</span><span>{st.label}</span></div>
      ))}
    </div>
  );
}

// Nivel A · pantalla completa (3a móvil / 3b desktop).
export function HitFullLoader({ progress = null, step = 0, steps = "page", done = false, leaving = false, onRetry }) {
  const rootRef = useRef(null);
  const list = typeof steps === "string" ? STEP_SETS[steps] || STEP_SETS.page : steps;
  const stateRef = useRef({});
  stateRef.current = { progress, step, steps: list, done };
  useHitFx(rootRef, stateRef);
  const slow = useSlow(!done);
  useEffect(() => {
    const main = document.querySelector("main");
    main?.setAttribute("aria-busy", "true");
    return () => main?.removeAttribute("aria-busy");
  }, []);
  return (
    <div ref={rootRef} className={`hl-full sx ${leaving ? "hl-leave" : ""}`} role="status" aria-live="polite" data-testid="hit-full-loader">
      <span data-fx="sr" className="sr-only">conectando con hit</span>
      <div className="hl-halo1" /><div className="hl-halo2" />
      <div className="hl-head hl-mono"><div className="hl-online"><span data-fx="blink" className="hl-dot" />HIT TCG · EN LÍNEA</div><div>ECU · 2026</div></div>
      <Scene />
      <div className="hl-text">
        <div className="hl-online hl-mono hl-desk-only"><span data-fx="blink" className="hl-dot" />HIT TCG · EN LÍNEA · ECU 2026</div>
        <div data-fx="status" className="hl-mono hl-status" data-testid="hit-full-loader-status">CONECTANDO CON HIT</div>
        <div className="hl-titlerow">
          <div className="hl-title">Abriendo<br /><span className="hl-it">el sobre</span></div>
          <div className="hl-pct"><span data-fx="pct" className="hl-pctn" data-testid="hit-full-loader-pct">··</span><span className="hl-pcts">%</span></div>
        </div>
        <Segments className="hl-bar" />
        <Steps steps={list} />
        {slow && <SlowNotice onRetry={onRetry} testid="hit-full-loader" />}
      </div>
      <div className="hl-foot hl-mono"><span>MARKETPLACE TCG SEGURO</span><span>HECHO EN ECUADOR</span></div>
    </div>
  );
}

// Host global (montado una vez en App). Al cerrar: "HIT ENCONTRADO" 400 ms + fade-out 300 ms.
export function HitFullLoaderHost() {
  const req = useFullLoaderState();
  const [shown, setShown] = useState(null);
  const [phase, setPhase] = useState("in");
  useEffect(() => {
    if (req) { setShown(req); setPhase("in"); return undefined; }
    if (!shown) return undefined;
    setPhase("done");
    const a = setTimeout(() => setPhase("out"), 400);
    const b = setTimeout(() => setShown(null), 700);
    return () => { clearTimeout(a); clearTimeout(b); };
  }, [req]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!shown) return null;
  return createPortal(
    <HitFullLoader {...shown} done={phase !== "in"} leaving={phase === "out"} />,
    document.body,
  );
}
